import React, { useEffect, useState } from "react";
import ReactPaginate from "react-paginate";
import { Row, Col } from "react-bootstrap";
import { useLocation } from "react-router-dom";
import queryString from "query-string";
import PropTypes from "prop-types";

const Paginate = ({ pagination, onClick }) => {
  const [viewPage, setViewPage] = useState(0);
  const location = useLocation();

  const handlePageClick = (data) => {
    setViewPage(data.selected);
    onClick(data.selected);
  };

  useEffect(() => {
    const parsed = queryString.parse(location.search);
    if (parsed.page) {
      setViewPage(Number(parsed.page) - 1);
    }
  }, [location]);

  if (!pagination || pagination.total === 0) return null;

  return (
    <div className="pagination_sec">
      <Row>
        <Col>
          Showing{" "}
          {(pagination.current_page - 1) * pagination.per_page + 1} to{" "}
          {Math.min(
            pagination.current_page * pagination.per_page,
            pagination.total
          )}{" "}
          of {pagination.total} entries
        </Col>

        <Col className="justify-content-end d-flex">
          <ReactPaginate
            forcePage={viewPage}
            pageCount={pagination.total_pages}
            marginPagesDisplayed={2}
            pageRangeDisplayed={2}
            onPageChange={handlePageClick}
            containerClassName={"pagination"}
            pageClassName={"page-item"}
            pageLinkClassName={"page-link"}
            previousClassName={"page-item"}
            nextClassName={"page-item"}
            previousLinkClassName={"page-link"}
            nextLinkClassName={"page-link"}
            activeClassName={"active"}
          />
        </Col>
      </Row>
    </div>
  );
};

Paginate.propTypes = {
  pagination: PropTypes.shape({
    total: PropTypes.number,
    count: PropTypes.number,
    per_page: PropTypes.number,
    current_page: PropTypes.number,
    total_pages: PropTypes.number,
  }),
  onClick: PropTypes.func.isRequired,
};

export default Paginate;